import { useEffect } from 'react';
import { publicAPI } from '../services/apiService';

const GoogleAnalytics = () => {
  useEffect(() => {
    const loadGoogleAnalytics = async () => {
      try {
        const response = await publicAPI.getAnalytics();
        const { google_analytics_id } = response.data;

        if (google_analytics_id) {
          // Load Google Analytics script
          const script = document.createElement('script');
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${google_analytics_id}`;
          document.head.appendChild(script);

          // Initialize Google Analytics
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            window.dataLayer.push(arguments);
          }
          gtag('js', new Date());
          gtag('config', google_analytics_id);

          // Make gtag available globally
          window.gtag = gtag;
        }
      } catch (error) {
        console.error('Error loading Google Analytics:', error);
      }
    };

    loadGoogleAnalytics();
  }, []);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;